(() => {
  if (window.bidoonExpertInitialized) return;
  window.bidoonExpertInitialized = true;
  function initialize(scope = document) {
    scope.querySelectorAll('[data-contact-form-type="ask-an-expert"]').forEach(wrapper => {
      const form = wrapper.querySelector('form');
      if (!form || form.dataset.enquiryReady) return;
      form.dataset.enquiryReady = 'true';
      const email = form.querySelector('[name="contact[email]"]');
      const message = form.querySelector('textarea');
      if (email) { email.required = true; email.autocomplete = 'email'; }
      if (message) { message.name = 'contact[body]'; message.required = true; }
      const name = form.querySelector('input[name="contact[your-name]"]');
      if (name) name.autocomplete = 'name';
      const phone = form.querySelector('input[name*="phone"]');
      if (phone) { phone.type = 'tel'; phone.autocomplete = 'tel'; }
      const result = wrapper.querySelector('[data-enquiry-result]');
      if (result) {
        customElements.whenDefined('side-drawer').then(() => {
          const popup = wrapper.closest('side-drawer');
          const opener = document.querySelector(`[data-side-drawer="#${popup.id}"] button`);
          popup.open(opener);
          result.focus();
        });
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', () => initialize());
})();
